<template>
  <div>
    <!-- hr icono help -->
    <v-row align="center">
      <v-col class="flex-grow-0 flex-shrink-0">
        <!-- TODO: traducir -->
        <strong class="cyan--text">{{ subtitle }}</strong>
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0">
        <v-divider></v-divider>
      </v-col>
      <v-col class="flex-grow-0 flex-shrink-1">
        <v-btn icon @click="showHelp = !showHelp">
          <v-icon color="primary lighten-1">help</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- help -->
    <v-slide-y-transition>
      <v-container class="pa-0" v-show="showHelp">
        <v-row class="ma-0">
          <v-col
            class="pa-4 mb-2 cyan lighten-4 grey--text text--darken-1"
            v-html="help"
          >
          </v-col>
        </v-row>
      </v-container>
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  name: "mdd-paso-subtitulo",
  props: ["subtitle", "help"],
  data: () => {
    return {
      showHelp: false
    };
  }
};
</script>
